<div style="justify-content: center; align-items: center; align-content: center; display: flex; flex-direction: column;">
  <p>{{ 'EXTRACTIONOPTIONSDIALOG.EXTRACTION' | translate }}</p>
<div style="display: flex; flex-direction: row; gap: 10px; margin-bottom: 10px;">
  <mat-checkbox color="primary" [checked]="withColor" (change)="changeColorOption($event.checked)">
    {{'EXTRACTIONOPTIONSDIALOG.WITH_COLORS' | translate}}</mat-checkbox>
 <mat-checkbox color="primary" [checked]="withFormatting" (change)="changeFormattingOption($event.checked)">
      {{'EXTRACTIONOPTIONSDIALOG.WITH_FORMATTING' | translate}}</mat-checkbox>
      <mat-checkbox color="primary" [checked]="withFormatting" (change)="changeSortOption($event.checked)">
        {{'EXTRACTIONOPTIONSDIALOG.SORT_COLORS' | translate}}</mat-checkbox>
</div>
<input type="submit" class="cb-btn" (click)="closeDlg()" value="{{ 'EXTRACTIONOPTIONSDIALOG.EXCTRACT' | translate }}"> 
</div>